import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { releaseApi } from "@/lib/api";

export function useReorderTracks(releaseId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (recordings: Array<{ sound_recording_id: string; track_number: string }>) =>
      releaseApi.syncReleaseRecordings(releaseId, recordings),
    onSuccess: () => {
      toast.success("Track order was changed");
      queryClient.invalidateQueries({ queryKey: ["release-details", releaseId] });
    },
    onError: () => {
      toast.error("Failed to update track order");
    },
  });
}
